import { z } from "zod";
const TM_TASK_TYPE = z.enum([
    "scan_zone",
    "scan_fixture",
    "scan_shelf",
    "scan_category",
    "recapture",
    "return_to_base",
    "manual_capture",
    "other",
]);
const TM_TASK_STATUS = z.enum([
    "created",
    "queued",
    "assigned",
    "in_progress",
    "completed",
    "failed",
    "cancelled",
    "skipped",
]);
const TM_SESSION_EVENT_TYPE = z.enum([
    "session_started",
    "session_completed",
    "session_failed",
    "session_partially_completed",
    "session_cancelled",
]);
// Control-plane: pause/resume/stop and their ack outcome.
const TM_CONTROL_ACTION = z.enum(["pause", "resume", "stop"]);
const TM_CONTROL_ACK_STATUS = z.enum(["completed", "failed"]);
const TM_NAVIGATION_TYPE = z.enum(["none", "manual", "waypoint", "zone", "fixture", "shelf"]);
const tmGoalPoints = z.array(z.record(z.unknown()));
export const tmBulkCreateTaskItem = z.object({
    taskType: TM_TASK_TYPE.default("other"),
    fixturePublicId: z.string().uuid().nullish(),
    categoryPublicId: z.string().uuid().nullish(),
    navigationType: TM_NAVIGATION_TYPE.default("none"),
    goalPoints: tmGoalPoints.default([]),
    sortOrder: z.number().int().nullish(),
    metadata: z.record(z.unknown()).default({}),
});
export const tmBulkCreateTasksRequest = z.object({
    tasks: z.array(tmBulkCreateTaskItem).min(1).max(500),
});
export const tmBulkCreateTasksResponse = z.object({
    created: z.number().int(),
    taskIds: z.array(z.string().uuid()),
});
export const tmUpdateTaskRequest = z
    .object({
    status: TM_TASK_STATUS.optional(),
    startedAt: z.string().datetime().nullish(),
    finishedAt: z.string().datetime().nullish(),
    navigationType: TM_NAVIGATION_TYPE.optional(),
    goalPoints: tmGoalPoints.optional(),
    metadata: z.record(z.unknown()).optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: "At least one field required" });
export const tmSessionEventRequest = z.object({
    eventType: TM_SESSION_EVENT_TYPE,
    occurredAt: z.string().datetime().optional(),
    // Optional human-readable reason — persisted to capture_sessions.failure_reason
    // for session_failed / session_partially_completed events.
    failureReason: z.string().nullish(),
    metadata: z.record(z.unknown()).default({}),
});
export const tmSessionEventResponse = z.object({
    sessionId: z.string().uuid(),
    status: z.string(),
});
// ── Control-action ack ───────────────────────────────────────────────────
// TMS confirms it entered/exited a pause/resume/stop. Flips
// capture_sessions.control_action_status (+ error / updated_at).
export const tmControlAckRequest = z.object({
    action: TM_CONTROL_ACTION,
    status: TM_CONTROL_ACK_STATUS,
    error: z.string().nullish(),
});
export const tmControlAckResponse = z.object({
    sessionId: z.string().uuid(),
    action: TM_CONTROL_ACTION,
    status: TM_CONTROL_ACK_STATUS,
});
// Attachment upload + finalize are multipart / parameterless respectively, so
// only the params shape is expressed here; responses reuse the captures module.
export const tmAttachmentParams = z.object({ captureId: z.string().uuid() });
//# sourceMappingURL=integrations-task-manager.schemas.js.map